import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import DemoRequestModal from '@/components/DemoRequestModal';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="w-full pt-16">
        <div className="flex flex-col lg:flex-row">
          <div className="w-full lg:w-2xl mx-auto px-5 lg:px-8 mb-12 flex flex-col justify-center text-center md:text-start">
            <h1 className="text-2xl md:text-5xl text-text-primary font-bold mb-2 md:mb-6">
              Powerful tools to simplify property management
            </h1>
            <p className="text-base md:text-2xl text-text-secondary mb-8">
              From managing residents to tracking finances everything you need in
              one smart platform.
            </p>

            <div className="flex flex-col md:flex-row items-center gap-3 md:gap-7">
              <Link
                to="/sign-in"
                className="text-sm md:text-lg text-white font-bold border-2 border-[#5761EB] bg-[#5761EB] px-3 md:px-6 py-2 md:py-3 rounded-lg hover:bg-[#4651DB] transition-colors"
              >
                Get Started Free
              </Link>
              <button
                onClick={() => setIsModalOpen(true)}
                className="text-sm md:text-lg bg-white font-bold text-[#5761EB] px-3 md:px-6 py-2 md:py-3 rounded-lg hover:bg-gray-50 transition-colors border-2 border-[#5761EB]"
              >
                Book a demo
              </button>
            </div>
          </div>
          <div>
            <div className="">
              <img
                src="/assets/images/home/feature-hero.png"
                alt="sobar house"
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>

      <DemoRequestModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Hero;
